module.exports = __webpack_public_path__ + "img/bpBJBlue.5ea5fa19.jpg";